import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Address } from "@app/address/model/address";

@Component({
    selector: "app-map-container",
    templateUrl: "./map-container.component.html",
    styleUrls: ["./map-container.component.scss"],
    encapsulation: ViewEncapsulation.None, // needed for map to display
})
export class MapContainerComponent implements OnInit {
    @Input() address: Address;

    public mapOptions: google.maps.MapOptions;
    public marker;

    ngOnInit(): void {
        this.initMap();
    }

    private initMap(): void {
        const parts = this.address.coordinates.split(",").map(part => parseFloat(part.trim()));
        const lat = parts[0];
        const lng = parts[1];
        this.marker = { position: { lat, lng } };

        this.mapOptions = {
            center: { lat, lng },
            zoom: 15,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
            ],
            streetViewControl: false,
            mapTypeControlOptions: {
                mapTypeIds: ["roadmap", "satellite"],
            },
        };
    }
}
